import { render, staticRenderFns } from "./ProductPurchaseIyzico.vue?vue&type=template&id=7adbd50d&"
import script from "./ProductPurchaseIyzico.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseIyzico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports